



































































































import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
const cssPrefix = 'msw-widget-card';

@Component({
  components: {
    SwIcon,
    SwSpinningProgress,
  },
})
export default class MswWidgetCard extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop(String) widgetTitle: string;
  @Prop({ type: Boolean, default: false }) isEmpty: boolean;
  @Prop({ type: Boolean, default: false }) isLoading: boolean;
}
